import React, { useContext, useState, useEffect } from "react";
import { Box, useTheme, Alert, Typography } from "@mui/material";
import { SiteContext, SingleContext } from "gatsby-frontend";

function AlertBanner() {
	const singleContext = useContext(SingleContext);
	const { isHome } = singleContext;
	let { alertBanners } = useContext(SiteContext);
	const alertBanner = alertBanners && alertBanners[0] ? alertBanners[0] : null;
	let severity = alertBanner ? alertBanner.severity : "info";
	let title = alertBanner ? alertBanner.name : null;
	let text = alertBanner ? alertBanner.description : null;
	const [showAlert, setShowAlert] = useState(false);

	useEffect(() => {
		const isDismissed =
			typeof window !== "undefined" &&
			window.localStorage.getItem("isDismissed") === "true";
		let show = !isDismissed &&
			isHome &&
			alertBanner &&
			alertBanner.show_alert &&
			(title !== null || text !== null);
		setShowAlert(show);
	}, []);

	const theme = useTheme();

	const handleClose = () => {
		setShowAlert(false);
		if (typeof window !== "undefined") {
			window.localStorage.setItem("isDismissed", JSON.stringify(true));
		}
	};

	function AlertBannerBlock() {
		return (
			<Box
				id="alertbanner"
				component="div"
				sx={{
					padding: 0,
					bottom: 0,
					paddingBottom: 0,
					width: "100%",
					backgroundColor: theme.palette.footer.main,
					color: theme.palette.footer.contrastText,
					...(theme.palette.footer.gradient && {
						backgroundImage: theme.palette.footer.gradient,
					}),
					"& a": {
						color: theme.palette.body.main,
					},
					"& p, & .subtitle": {
						fontSize: "0.9em",
						lineHeight: 1.4,
						margin: 0,
					},
					"& .subtitle": {
						fontWeight: theme.typography.fontWeightBold,
						margin: 0,
					},
					"& .colophon": {
						"& p, & .subtitle": {
							fontSize: "0.8em",
						},
					},
				}}
			>
				<Alert
					onClose={handleClose}
					severity={severity}
					sx={(theme) => ({
						justifyContent: "center",
						bottom: 0,
						paddingBottom: 0,
						"& .MuiAlert-icon": {
							display: "none",
						},
						"& .MuiAlert-message": {
							fontSize: theme.typography.fontSizeLg,
							fontWeight: theme.typography.fontWeightBold,
						},
					})}
				>
					<Typography
						component="div"
						variant="h4"
						sx={(theme) => ({
							marginLeft: theme.spacing(1),
							bottom: 0,
							margin: 0,
							paddingBottom: 0,
							left: 0,
						})}
					>
						{title}
					</Typography>
					<Box
						dangerouslySetInnerHTML={{ __html: text }}
						className="alertbannertext"
						sx={(theme) => ({
							marginLeft: theme.spacing(1),
							bottom: 0,
							marginBottom: 0,
							paddingBottom: 0,
							left: 0,
							"& a": {
								color: theme.palette.body.contrastText,
								paddingBottom: 0,
								marginBottom: 0,
							},
						})}
					></Box>
				</Alert>
			</Box>
		);
	}

	return <>{showAlert && <AlertBannerBlock />}</>;
}

export default AlertBanner;
